import React, { useEffect, useState } from "react"
import { withPrefix } from "gatsby"
import styled from "styled-components"
import ReactHtmlParser from "react-html-parser"

import Title from "@airasia/phoenix-components/components/Title"
import Image from "@airasia/phoenix-components/components/Image"
import Text from "@airasia/phoenix-components/components/Text"
import Button from "@airasia/phoenix-components/components/Button"
import CouponBox from "@airasia/phoenix-components/components/CouponBox"

import { GTM_PROJECT_CATEGORY } from "../utils/constants";
import { getGtmUserType, fireGtmEvent } from "../utils/functions";


  var Container =styled.div`
    margin:1em auto;
    width:40%;
    border-radius:30px;
    text-align:center;
    box-shadow: 0 2px 4px 2px #00000015;


    @media screen and (max-width: 768px) {
        width: 100%;
        padding:0em;
        
  }
`

var ContainerContent =styled.div`
    top:3em;
    padding:20px;

    #title{font-size:38px; font-weight:800;}
    
    @media screen and (max-width: 768px) {
        padding:2em;
  }
`
var Content_Desc =styled.p`
    padding: 0px;
    display:block;

    @media screen and (max-width: 768px) {
      text-align:center;
    }
`

var BoxIcon = styled.div`
  float:right;
  width:100%;

  #icon-image{float:right; text-align:right;}
`

var BoxContent =styled.div`
       width: 50%;
    margin: 20px auto;

   @media screen and (max-width: 768px) {
      text-align:center;
      width:100%;
    }

`

export default function CouponCode(props) {
  const desktopLink = "https://www.airasia.com/flight/en/gb?promocode=BIGPAY5"
  const mobileLink = "https://www.airasia.com/flight/en/gb?promocode=BIGPAY5"
  console.log("desktopLink", desktopLink);
    console.log("mobileLink", props.mobileLink);

  // Use the 'useState' hook to get the current screen size and set a default value
  const [screenSize, setScreenSize] = useState('desktop')

  // Use the 'useEffect' hook to update the screen size whenever the window is resized
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      setScreenSize(width <= 768 ? 'mobile' : 'desktop')
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Set the link based on the current screen size
  const ctaLink = screenSize === 'mobile' ? mobileLink : desktopLink

  return (
    <Container>
      <ContainerContent>
        <BoxIcon>
          <Image
            accessible
            width="30%"
            placeHolderBackground="none"
            customProperties={{ id: "icon-image" }}
            src={props.image}
            alt={props.title}
          />
        </BoxIcon>

        <Title
          accessible
          inverted={false}
          textAlign="center"
          theme="AIRASIA_CLASSIC"
          type="h2"
          color="primary"
          customProperties={{ id: "title" }}
        >
          {props.title}
        </Title>

        <BoxContent>
          <CouponBox
            accessible
            couponCode="BIGPAY5"
            couponTextColor="neutral"
            couponTextSize="default"
            ctaLinkColor="secondary"
            ctaLinkHoverColor="secondary"
            ctaLinkHoverUnderlined
            ctaLinkTarget="tab"
            ctaLinkText="Copy"
            ctaLinkUnderlined={false}
            labelColor="greyMedium"
            labelSize="sub"
            labelText={props.label}
            theme="AIRASIA_CLASSIC"
          />
        </BoxContent>
        <Content_Desc>
          <Text
            accessible
            display="block"
            hasToggle={false}
            opacity={1}
            tag="p"
            textAlign="center"
            theme="AIRASIA_CLASSIC"
            translation={{}}
            type="small"
            width="100%"
          >
            {ReactHtmlParser(props.description)}
          </Text>
          <br />
          <Button
                    accessible
                    buttonType="button"
                    backgroundColor="primary"
                     boxShadow
                    customProperties={{id: 'signup-cta'}}
                    fontWeight="bold"
                    size="normal"
                    target="tab"
                    type="normal"
                    color="default"
                    target="tab"
                    handleClick={() => {
                      fireGtmEvent({
                        "event": "trackEventNoEcommerce",
                        "eventDetails.category": "aa bigpay",
                        "eventDetails.action": "click",
                        "eventDetails.label": "book now | aa bigpay",
                      })
                      window.open(ctaLink)
                    }}
                  >
                    {props.cta}
                  </Button>
          {/* <Button
            accessible
            backgroundColor="primary"
            boxShadow
            buttonType="link"
            cardIndex={0}
            color="default"
            defaultDisabledFeatures
            disabled={false}
            fontWeight="normal"
            hoverBackgroundColor="primary"
            hoverColor="default"
            size="normal"
            target="tab"
            theme="AIRASIA_CLASSIC"
            type="normal"
            href={ctaLink}
            handleClick={() => {
              fireGtmEvent({
                "event": "trackEventNoEcommerce",
                "eventDetails.category": "aa bigpay",
                "eventDetails.action": "click",
                "eventDetails.label": "book now2",
              })
            }}
          >
            {props.cta}
          </Button> */}
        </Content_Desc>
      </ContainerContent>
    </Container>
  )
}
